import { yupResolver } from '@hookform/resolvers/yup';
import { Typography } from '@mui/material';
import OrderSummary from 'Components/Payment/OrderSummary';
import AdmissionItems from 'Pages/AdmissionItems';
import MultipleSession from 'Pages/MultipleSession';
import { useEffect, useState } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import multipleSessionSchema from 'Validation/multipleSessionSchema';

const StepBasedRegistration = () => {
  const [activeStep, setActiveStep] = useState(0);

  const methods = useForm({
    defaultValues: {
      selectedOption: '',
      filteredSessionsData: [],
      selectedValues: []
    },
    resolver: yupResolver(multipleSessionSchema(activeStep)),
    mode: 'all'
  });

  const { control, getValues, setValue } = methods;

  const selectedOption = useWatch({
    control,
    name: 'selectedOption'
  });

  useEffect(() => {
    if (selectedOption) {
      setValue('selectedValues', []);
    }
  }, [selectedOption, setValue]);

  const navigate = useNavigate();
  const location = useLocation();
  const { eventDetails } = location.state || {};

  const handleNext = async () => {
    const isValid = await methods.trigger();
    if (!isValid) return;
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    if (activeStep === 0) {
      if (eventDetails) {
        navigate(`/events/${eventDetails.eventId}`);
      } else {
        navigate(-1);
      }
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const handleCancel = () => navigate(-1);

  const navigateToStep = (step) => {
    switch (step) {
      case 0:
        return (
          <MultipleSession
            eventDetails={eventDetails}
            onPrevious={handleBack}
            onNext={handleNext}
            onCancel={handleCancel}
          />
        );
      case 1:
        return (
          <AdmissionItems
            eventDetails={eventDetails}
            onPrevious={handleBack}
            onNext={handleNext}
            onCancel={handleCancel}
          />
        );
      case 2:
        return <OrderSummary selectedValues={getValues('selectedValues')} hideHeader={true} />;
      default:
        return null;
    }
  };

  return (
    <>
      <div className="breadcrumb">
        <Typography variant="h6" className="breadcrumbText">
          {eventDetails?.title}
        </Typography>
      </div>
      <FormProvider {...methods}>{navigateToStep(activeStep)}</FormProvider>
    </>
  );
};

export default StepBasedRegistration;
